import RejectedStageDialog from "./job-details/RejectedStageDialog";
import React, { useState } from "react";
import { Alert, Button, Menu, MenuItem } from "@mui/material";
import { RECRUITING_STAGES, pipelineStageKey } from "../utils/pipelineStages";
import { schedulingRequest } from "../utils/interviewScheduling";
import { recordsChanged } from "../utils/recordChanges";

export default function ActivityRecruitingStage({ item }) {
  const [rejectionOpen, setRejectionOpen] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const candidateId = Number(item.entityType === "candidate" ? item.entityId : item.metadata?.candidate_id);
  const jobId = Number(item.entityType === "job" ? item.entityId : item.metadata?.job_id);
  if (!item.currentRecruitingStage || !(candidateId > 0 && jobId > 0)) return null;
  async function move(stage, rejection) {
    if (stage === "Rejected" && !rejection) { setAnchor(null); setRejectionOpen(true); return; }
    setAnchor(null); setBusy(true); setError("");
    try {
      await schedulingRequest(`/jobs/${jobId}/matches/stage`, { method: "PATCH", body: JSON.stringify({ candidate_ids: [candidateId], stage, ...rejection }) });
      recordsChanged();
      setRejectionOpen(false);
    } catch (err) { setError(err.message); if (rejection) throw err; }
    finally { setBusy(false); }
  }
  return <>
    <Button size="small" disabled={busy} onClick={event => setAnchor(event.currentTarget)}>Move stage</Button>
    <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
      {RECRUITING_STAGES.map(stage => <MenuItem key={stage.id} disabled={pipelineStageKey(item.currentRecruitingStage) === stage.id} onClick={() => move(stage.label)}>{stage.label}</MenuItem>)}
    </Menu>
    <RejectedStageDialog jobSpecific open={rejectionOpen} loading={busy} onClose={() => setRejectionOpen(false)} onSubmit={(rejection) => move("Rejected", rejection)} />
    {error && <Alert severity="error">{error}</Alert>}
  </>;
}
